import * as React from "react";
import {Badge, Chip, Stack, styled, Typography} from "@mui/material";
import Box from "@mui/material/Box";
import { ITimeFrame, TIME_FRAME_LAST_MONTH, TIME_FRAME_THIS_MONTH, TimeFrame } from "../../../../config/time_frames";
import { ITransactionsSearchFormOutputData } from "../../../../config/search";
import { DEFAULT_SEARCH_PARAMS } from "../../../../stores/search";
import { useGlobalStores } from "../../../../hooks/use_global_stores";

const Container = styled(Box)(({theme}) => ({
    padding: theme.spacing(3),
    paddingBottom: theme.spacing(1),
}));

const options = [
    TIME_FRAME_THIS_MONTH,
    TIME_FRAME_LAST_MONTH,
] as ITimeFrame[];

interface IOneClickSearchesProps {
    onSubmit(query: ITransactionsSearchFormOutputData): void;
    onReset(): void;
}

export const OneClickSearches = ({onSubmit, onReset}: IOneClickSearchesProps) => {
    const { searchStore } = useGlobalStores();

    const [value, setValue] = React.useState<TimeFrame | undefined>(
        !!searchStore.queryFormData.oneClick ? searchStore.queryFormData.timePeriod : undefined
    );

    const handleChange = (value: ITimeFrame) => () => {
        setValue(value.timeFrame);

        onSubmit({
            ...DEFAULT_SEARCH_PARAMS,
            oneClick: true,
            timePeriod: value.timeFrame!,
            timeRange: value.getRange(),
        });
    };

    return (
        <Container>
            <Typography variant="button" color="grey" component="div" sx={{marginBottom: 1}}>One click seraches</Typography>
            <Stack direction="row" spacing={1}>
                {options.map((v, i) => {
                    if (v.timeFrame === value) {
                        return (
                            <Badge
                                key={i}
                                color="error"
                                badgeContent=" "
                                variant="dot"
                                anchorOrigin={{
                                    vertical: 'top',
                                    horizontal: 'left',
                                }}
                            >
                                <Chip label={v.label} color="primary" onClick={handleChange(v)} />
                            </Badge>
                        );
                    }

                    return (
                        <Chip key={i} label={v.label} color="primary" onClick={handleChange(v)} />
                    );
                })}

                {!!value && <Chip label="Reset" variant="outlined" color="error" onClick={onReset} />}
            </Stack>
        </Container>
    );
};
